import React from 'react';
import LayoutProvider from '../../../../../../Contexts/LayoutProvider';
import LibModal from '../../../../../../features/LibModal/LibModal';
import { useTemplate } from '../../../../../../features/template/TemplateProvider';
import { ApiDeleteServicePackagePricing } from '../../../ServiceOperation';
import UpdatePackagePriceModal from '../../Modals/UpdatePackagePriceModal';
import { useServiceDt } from '../../ServiceDetailsProvider';
import PricingTableWeb from './PricingTableWeb';
import TableMobile from './TableMobile';

function PricingTable({ show }) {
    const {
        serviceInfo,
        openModal,
        closeModal,
        handleReload,
        packageInfo,
        productInfo,
        filteredCurrencies,
        modalType,
        modalData
    } = useServiceDt();
    const { setConfirm, setMessage } = useTemplate();

    const data = packageInfo?.pricing;

    // check package and product status
    const isPackageOrProductInactive =
        packageInfo?.status === 'inactive' || productInfo?.status === 'inactive';

    // delete pricing
    const handleDelete = (e, pricingId) => {
        e.stopPropagation();
        setConfirm({
            text: 'Are you sure you want to delete this pricing?',
            clickAction: () => {
                ApiDeleteServicePackagePricing(serviceInfo?.id, packageInfo?.id, pricingId)
                    .then(({ title }) => {
                        setMessage({ type: 'success', text: title });
                        setConfirm(null);
                        handleReload();
                    })
                    .catch((err) => {
                        setMessage({ type: 'error', text: err.toString() });
                    });
            }
        });
    };
    if (!show) {
        return null;
    }
    return (
        <>
            <LayoutProvider>
                <PricingTableWeb
                    layout="default"
                    data={data}
                    isPackageOrProductInactive={isPackageOrProductInactive}
                    openModal={openModal}
                    filteredCurrencies={filteredCurrencies}
                    handleDelete={handleDelete}
                />
                <TableMobile
                    layout={['lg', 'md', 'sm', 'xs', 'xxs']}
                    data={data}
                    isPackageOrProductInactive={isPackageOrProductInactive}
                    openModal={openModal}
                    handleDelete={handleDelete}
                    filteredCurrencies={filteredCurrencies}
                />
            </LayoutProvider>

            {modalType === 'package-pricing' && (
                <LibModal title="Update Package Price" setOpen={closeModal}>
                    <UpdatePackagePriceModal
                        closeModal={closeModal}
                        handleReload={handleReload}
                        modalData={modalData}
                    />
                </LibModal>
            )}
        </>
    );
}

export default PricingTable;
